import { request } from '@max/meituan-uni-network';
// import { isWeb } from '@max/meituan-uni-env';
// import { reportJSInfo } from '@max/meituan-uni-report';
// import { AntiReqTool } from '@nibfe/h5guard-request';
import { CLIENT_CONTAINER, CLIENT_OS, CLIENT_PLATFORM } from '@lowcode/mcp-protocol/src/base/common';
import { BASE_CLIENT_TYPE, PLATFORM, SOURCE } from '../types/api';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    PROD: 'https://ihotel.meituan.com',
    TEST: '',
    DEV: ''
};
export const API_PATH = {
    SUPPLY_LIST: '/landing/page/surrounding/supply?'
};
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 3] = "ERROR";
})(RequestStatus || (RequestStatus = {}));
export const getRequestPlatform = (platform) => {
    let result = PLATFORM.MEITUAN;
    if (platform === CLIENT_PLATFORM.DP) {
        result = PLATFORM.DIANPING;
    }
    return result;
};
export const getRequestSource = (clientContainer) => {
    let result = SOURCE.MEITUAN_APP;
    switch (clientContainer) {
        case CLIENT_CONTAINER.DIANPING_APP:
        case CLIENT_CONTAINER.DIANPING_WEBVIEW:
            result = SOURCE.DIANPING_APP;
            break;
        case CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM:
            result = SOURCE.MEITUAN_MINIAPP;
            break;
        case CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM:
            result = SOURCE.HOTEL_MINIAPP;
            break;
        case CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM:
            result = SOURCE.DIANPING_MINIAPP;
            break;
        default:
            break;
    }
    return result;
};
export const getRequestClientType = (clientContainer, os) => {
    if ([CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM, CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM, CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM].indexOf(clientContainer) > -1) {
        return BASE_CLIENT_TYPE.WX;
    }
    if (os === CLIENT_OS.ANDROID) {
        return BASE_CLIENT_TYPE.ANDROID;
    }
    if (os === CLIENT_OS.HARMONY) {
        return BASE_CLIENT_TYPE.HARMONY;
    }
    return BASE_CLIENT_TYPE.IPHONE;
};
export const requestDataCenter = (requestConfig) => {
    const { path, method, params } = requestConfig;
    let finalRequestParams = params;
    // 视情况加上反爬参数
    // if (isWeb) {
    //   try {
    //     const antiReq = new AntiReqTool({ autoFillParams: true });
    //     // @ts-ignore
    //     finalRequestParams = antiReq.addCommonParams(finalRequestParams);
    //   } catch {
    //     reportJSInfo({ level: 'info', content: '请求加上反爬参数错误', secCategory: 'ajaxError' }).catch();
    //   }
    // }
    // 导入环境判断API
    const { getSystemType, SystemType } = require('@nibfe/mkt-env-api');
    const systemType = getSystemType();
    const isAndroid = systemType === SystemType.android;
    const isIOS = systemType === SystemType.ios;
    const isInHarmony = systemType === SystemType.harmony;
    const defaultUtmMedium = isIOS ? 'iphone' : isAndroid ? 'android' : isInHarmony ? 'HarmonyOS' : 'android';
    const utmParams = {
        utm_campaign: params?.utm_campaign || 'AgroupBgroupC0D100E0',
        // 决定筛选POI的城市体系
        utm_content: params?.utm_content || '017378c7bafb490da04f4d4cc952a564a174867136574417169',
        utm_medium: params?.utm_medium || defaultUtmMedium,
        utm_source: params?.utm_source || 'meituaninternaltest',
        utm_term: params?.utm_term || '1200420200',
        version_name: params?.version_name || '12.42.200'
    };
    if (isInHarmony) {
        utmParams.platform = params?.platform || 60;
    }
    const utmParmas = objToUrlParams(utmParams);
    return new Promise((resolve, reject) => {
        request({
            url: `${API_MAP.PROD}${path}${utmParmas}`,
            data: {
                ...finalRequestParams
            },
            method,
            header: {
                'content-type': 'application/json'
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
            },
            success(res) {
                if (res?.data) {
                    const templateRes = res?.data;
                    resolve(templateRes);
                }
                else {
                    reject(new Error(AJAX_ERROR_NAME));
                }
            },
            fail(error) {
                reject(error);
            }
        });
    });
};
function objToUrlParams(obj) {
    return Object.entries(obj).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
}
